// TODO: 不要なのですること

// auth.js
export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN'
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR'
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE'
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS'
export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN'
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR'
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE'
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS'
export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_CLEAR = 'LOGIN_CLEAR'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const USER_BEGIN = 'USER_BEGIN'
export const USER_FAILURE = 'USER_FAILURE'
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_SET = 'USER_SET'
export const GET_USERS = 'GET_USERS'
export const SET_USERS = 'SET_USERS'
export const SET_DEACTIVATED_USERS = 'SET_DEACTIVATED_USERS'
export const GET_HOME_DATA = 'GET_HOME_DATA'
export const ADD_MEMBER = 'ADD_MEMBER'
export const READD_MEMBER = 'READD_MEMBER'
export const PROFILE_SET = 'PROFILE_SET'
export const PROFILE_SET_U = 'PROFILE_SET_U'
export const SET_USER_ICON = 'SET_USER_ICON'
export const SET_USER_CONNECT = 'SET_USER_CONNECT'
export const SET_COLOR = 'SET_COLOR'
export const SET_POWER = 'SET_POWER'
export const ADD_CARD = 'ADD_CARD'
export const SET_CARD = 'SET_CARD'
export const SET_CARDS_ORDER = 'SET_CARDS_ORDER'
export const EDIT_CARD = 'EDIT_CARD'
export const DELETE_CARD = 'DELETE_CARD'
export const ADD_FAVORITE = 'ADD_FAVORITE'
export const SET_FAVORITE = 'SET_FAVORITE'
export const EDIT_FAVORITE = 'EDIT_FAVORITE'
export const DELETE_FAVORITE = 'DELETE_FAVORITE'
export const SET_RH_MODAL = 'SET_RH_MODAL'
export const SEND_RH = 'SEND_RH'
export const SET_PR_MODAL = 'SET_PR_MODAL'
export const SEND_PR = 'SEND_PR'
export const CHK_TKN = 'CHK_TKN'
export const RE_ISSUE = 'RE_ISSUE'
export const RE_CREATE_PASS = 'RE_CREATE_PASS'
export const GET_COMPANY_LIST = 'GET_COMPANY_LIST'
export const SET_USER_COMPANY = 'SET_USER_COMPANY'
export const SET_SLACK = 'SET_SLACK'
export const GET_SLACK = 'GET_SLACK'
export const SAVE_SLACK = 'SAVE_SLACK'
export const POST_SLACK = 'POST_SLACK'
export const DELETE_SLACK_LINK = 'DELETE_SLACK_LINK'
export const SET_CW = 'SET_CW'
export const GET_CW = 'GET_CW'
export const PUT_CW = 'PUT_CW'
export const POST_CW = 'POST_CW'
export const SAVE_CW = 'SAVE_CW'
export const DELETE_CW_LINK = 'DELETE_CW_LINK'
export const GOOGLE_AUTH_REVOKE = 'GOOGLE_AUTH_REVOKE'
export const SET_ICON_IMG = 'SET_ICON_IMG'
export const GET_WT = 'GET_WT'
export const PUT_WT = 'PUT_WT'
export const POST_WT = 'POST_WT'
export const POST_WT_LINK = 'POST_WT_LINK'
export const DELETE_WT_LINK = 'DELETE_WT_LINK'
export const GET_SEARCH = 'GET_SEARCH'
export const GET_QUERY = 'GET_QUERY'
export const GET_QUERY_DELET = 'GET_QUERY_DELET'
export const SEND_SBSCB = 'SEND_SBSCB'
export const DEMO_IMAGE = 'DEMO_IMAGE'
export const SEND_CV = 'SEND_CV'
export const SEND_CV_NO = 'SEND_CV_NO'
export const SET_TOP = 'SET_TOP'
export const PROFILE_IMAGE = 'PROFILE_IMAGE'
export const GET_CATEGORY = 'GET_CATEGORY'
export const PUT_CATEGORY = 'PUT_CATEGORY'
export const POST_CATEGORY = 'POST_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const OMIT_RECENT_APPLICANT_DUPFLG = 'OMIT_RECENT_APPLICANT_DUPFLG'
export const SET_RECENT_APPLICANT_DUPFLG = 'SET_RECENT_APPLICANT_DUPFLG'

// directtalk.js
export const MESSAGE_BEGIN = 'MESSAGE_BEGIN'
export const MESSAGE_FAILURE = 'MESSAGE_FAILURE'
export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS'
export const SET_JSON = 'SET_JSON'
export const SET_MANAGER = 'SET_MANAGER'
export const SELECT_ROOM = 'SELECT_ROOM'
export const GET_URL_LIST = 'GET_URL_LIST'
export const SYNC_ROOM = 'SYNC_ROOM'
export const CLEAR_ROOM = 'CLEAR_ROOM'
export const SELECT_ACTION = 'SELECT_ACTION'
export const CONNECT_BEGIN = 'CONNECT_BEGIN'
export const CONNECT_END = 'CONNECT_END'
export const CONNECT_LIST = 'CONNECT_LIST'
export const CONNECT_GET_ROOM = 'CONNECT_GET_ROOM'
export const SET_SEEKER = 'SET_SEEKER'
export const GET_SEEKER = 'GET_SEEKER'
export const GET_MESSAGE = 'GET_MESSAGE'
export const IMP_MESSAGE = 'IMP_MESSAGE'
export const GET_ROOM = 'GET_ROOM'
export const NOW_LOADING = 'NOW_LOADING'
export const MESSAGE_TYPING = 'MESSAGE_TYPING'
export const SET_CALENDAR = 'SET_CALENDAR'
export const SET_SEEKER_FROM_INFO = 'SET_SEEKER_FROM_INFO'
export const WIDGET_RECEIVE = 'WIDGET_RECEIVE'
export const MOBILE_TYPE = 'MOBILE_TYPE'
export const CREATE_SEEKER_EVENT = 'CREATE_SEEKER_EVENT'
export const SET_SK_AT_HS = 'SET_SK_AT_HS'
export const SET_ISREAD = 'SET_ISREAD'
export const MORE_ROOM = 'MORE_ROOM'
export const ADD_COUNT = 'ADD_COUNT'
export const SEEKER_COUNT = 'SEEKER_COUNT'
export const SET_DT = 'SET_DT'
export const SET_FV = 'SET_FV'
export const SET_DT_N = 'SET_DT_N'
export const SET_CB = 'SET_CB'
export const SET_SD = 'SET_SD'
export const SET_SC = 'SET_SC'
export const SET_WDT_SEEKER = 'SET_WDT_SEEKER'
export const SET_ACTION = 'SET_ACTION'
export const GET_ROOM_LIST = 'GET_ROOM_LIST'
export const SET_STAR = 'SET_STAR'
export const GET_GRAPH_DATA = 'GET_GRAPH_DATA'
export const OPEN_LOADING = 'OPEN_LOADING'
export const GET_READ_COUNT = 'GET_READ_COUNT'
export const GET_SK_APPLY = 'GET_SK_APPLY'
export const UPDATE_SK = 'UPDATE_SK'
export const CSV_EXPORT = 'CSV_EXPORT'
export const RESUME_CREATE = 'RESUME_CREATE'
export const RESUME_CREATE_DEMO = 'RESUME_CREATE_DEMO'
export const OPEN_VIDEO_INTERVIEW = 'OPEN_VIDEO_INTERVIEW'
export const CLOSE_VIDEO_INTERVIEW = 'CLOSE_VIDEO_INTERVIEW'
export const RESUME_GET = 'RESUME_GET'
export const SET_MANAGE = 'SET_MANAGE'
export const GET_LM = 'GET_LM'
export const GET_RE_LM = 'GET_RE_LM'
export const MAKE_DIALOG_CSV = 'MAKE_DIALOG_CSV'
export const SCROLL_TALK = 'SCROLL_TALK'
export const UPLOAD_OCR = 'UPLOAD_OCR'

// calendar.js
export const IS_GOOGLE_AUTH = 'IS_GOOGLE_AUTH'
export const GOOGLE_AUTH_REDIRECT = 'GOOGLE_AUTH_REDIRECT'
export const GET_GOOGLE_CALENDAR = 'GET_GOOGLE_CALENDAR'
export const GET_GAROON_CALENDAR = 'GET_GAROON_CALENDAR'
export const ADD_EVENT = 'ADD_EVENT'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const REMOVE_EVENT = 'REMOVE_EVENT'
export const START_RECOMMEND_DATE = 'START_RECOMMEND_DATE'
export const END_RECOMMEND_DATE = 'END_RECOMMEND_DATE'
export const GET_SCHEDULE = 'GET_SCHEDULE'
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE'
export const SET_SCHEDULE = 'SET_SCHEDULE'
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE'
export const CHANGE_GOOGLE_AUTH = 'CHANGE_GOOGLE_AUTH'
export const GET_RECOMMEND_DATE = 'GET_RECOMMEND_DATE'
export const GET_REC_SCE = 'GET_REC_SCE'
export const AUTO_CREATE_SCHEDULE = 'AUTO_CREATE_SCHEDULE'

// setting.js
export const ST_MENU_SELECT = 'ST_MENU_SELECT'
export const ST_BILLING_MODAL = 'ST_BILLING_MODAL'
export const ST_BILLING_SAVE = 'ST_BILLING_SAVE'

// employmentPage.js
export const EP_CTS_SEL = 'EP_CTS_SEL'
export const EP_CTS_GET = 'EP_CTS_GET'
export const EP_CTS_GET_PUB = 'EP_CTS_GET_PUB'
export const EP_CTS_POST = 'EP_CTS_POST'
export const EP_CTS_PUT = 'EP_CTS_PUT'
export const EP_CTS_CNT = 'EP_CTS_CNT'
export const EP_CTS_DELETE = 'EP_CTS_DELETE'
export const EP_CTS_POST_REC = 'EP_CTS_POST_REC'
export const EP_CTS_IMG_POST = 'EP_CTS_IMG_POST'
export const EP_MCTS_IMG_POST = 'EP_MCTS_IMG_POST'
export const EP_CTS_IMP_POST = 'EP_CTS_IMP_POST'
export const EP_CTS_NEXT = 'EP_CTS_NEXT'
export const EP_CTS_PREV = 'EP_CTS_PREV'
export const EP_CTS_SECH = 'EP_CTS_SECH'
export const EP_CTS_APPLY = 'EP_CTS_APPLY'
export const EP_RCTS_POST = 'EP_RCTS_POST'
export const EP_RCTS_PUT  = 'EP_RCTS_PUT'
export const EP_RCTS_GET  = 'EP_RCTS_GET'
export const EP_RCTS_DEL  = 'EP_RCTS_DEL'
// help.js
export const HE_IT_GET = 'HE_IT_GET'
export const HE_IT_CREATE = 'HE_IT_CREATE'
export const HE_IT_DELETE = 'HE_IT_DELETE'
export const HE_IT_UPDATE = 'HE_IT_UPDATE'
export const HE_ID_UPDATE = 'HE_ID_UPDATE'
export const HE_IM_UPDATE = 'HE_IM_UPDATE'
export const HE_GET = 'HE_GET'
export const HE_DELETE = 'HE_DELETE'
export const HE_CREATE = 'HE_CREATE'
export const HE_IM_GET = 'HE_IM_GET'
export const TAB_LOADING = 'TAB_LOADING'
export const HE_UPDATE = 'HE_UPDATE'
export const HE_SET = 'HE_SET'



// WEBPACK FOOTER //
// ./src/store/types.js